import imageCompression from 'browser-image-compression';
const IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/bmp'];
const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp', '.bmp'];
const COMPRESSION_OPTIONS = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
};
const isImageFile = (file) => {
    if (IMAGE_MIME_TYPES.includes(file.type)) {
        return true;
    }
    const extension = file.name.toLowerCase().split('.').pop();
    return extension ? IMAGE_EXTENSIONS.includes(`.${extension}`) : false;
};
export const compressImage = async (file) => {
    if (!isImageFile(file)) {
        return file;
    }
    try {
        const compressedFile = await imageCompression(file, COMPRESSION_OPTIONS);
        return new File([compressedFile], file.name, {
            type: compressedFile.type,
            lastModified: Date.now(),
        });
    }
    catch {
        return file;
    }
};
